<template>
  <div class="ds-page" v-if="!$store.getters.isForbidden">
    <div class="page-header d-print-none">
      <div class="row align-items-center">
        <div class="col">
          <div class="page-pretitle">Refferral</div>
          <h2 class="page-title">{{ $route.name }} List</h2>
          <p class="page-subtitle">
            Manage dynamic referral campaign rules, rewards, maximum claim allocations, and
            categories.
          </p>
        </div>
        <div class="col-auto ms-auto">
          <div class="cc-page__header-actions">
            <button
              class="ds-btn ds-btn--blue"
              v-b-modal.add
              @click="
                loadCompanies();
                getListCategory();
              "
            >
              <font-awesome-icon icon="plus" />
              Create Referral Program
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="ds-card">
      <div class="cc-page__table-head">
        <div>
          <div class="cc-page__table-title">Filters</div>
          <div class="cc-page__table-subtitle">Search by referral name</div>
        </div>
      </div>

      <div class="cc-page__filter-grid">
        <div class="ds-field">
          <label class="ds-field__label">Search Name</label>
          <el-input
            v-model="search_referral.search_value"
            @clear="searchHandler"
            size="small"
            placeholder="Input search keyword"
            clearable
          />
        </div>
        <div class="ds-field">
          <label class="ds-field__label">Sort By</label>
          <el-select
            size="small"
            v-model="search_referral.sort_by"
            placeholder="Sort By"
            class="mr-2 w-full"
            filterable
            style="width: 100px"
          >
            <el-option
              v-for="item in sortByOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="ds-field">
          <label class="ds-field__label">Order By</label>
          <el-select
            size="small"
            v-model="search_referral.order_by"
            placeholder="Order By"
            class="mr-2 w-full"
            filterable
            style="width: 100px"
          >
            <el-option
              v-for="item in orderByOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="cc-page__filter-actions">
          <button class="ds-btn ds-btn--secondary ds-btn--sm">Reset</button>
          <button @click="searchHandler" class="ds-btn ds-btn--primary ds-btn--sm">Search</button>
        </div>
      </div>
    </div>

    <div class="ds-card">
      <div class="ds-table-wrap">
        <table class="ds-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Program Name</th>
              <th>Referral Category</th>
              <th class="text-right">Referred Amount</th>
              <th class="text-right">Referrer Amount</th>
              <th class="text-center">Max Claim</th>
              <th>Period</th>
              <th>Status</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in list" :key="i">
              <td>
                <span class="cc-page__identity-sub">#{{ item?.id }}</span>
              </td>
              <td>
                <span class="cc-page__identity-sub">{{ item?.start_date_str }}</span>
              </td>
              <td>
                <span class="cc-page__identity-sub">{{ item?.end_date_str }}</span>
              </td>
              <td>
                <div class="cc-page__identity">
                  <span class="cc-page__identity-name">{{ item?.name || '—' }}</span>
                </div>
              </td>
              <td>
                <span class="ds-pill ds-pill--secondary">{{
                  item.referral_category?.name || '—'
                }}</span>
              </td>
              <td class="text-right font-weight-bold text-success">
                {{ item?.referred_amount_str }}
              </td>
              <td class="text-right font-weight-bold text-primary">
                {{ item?.referrer_amount_str }}
              </td>
              <td class="text-center">
                <span class="badge bg-light text-dark px-2 py-1">{{ item?.max_claim }}</span>
              </td>
              <td>
                <span class="text-capitalize">{{ item?.period }}</span>
              </td>
              <td>
                <span class="ds-pill" :class="item.status_color">
                  {{ item.status_str }}
                </span>
              </td>
              <td class="text-center">
                <el-dropdown
                  trigger="hover"
                  @command="handleActionCommand($event, item)"
                  popper-class="cc-page__action-popper"
                >
                  <button class="ds-btn ds-btn--secondary ds-btn--sm cc-page__action-trigger">
                    Actions <i class="el-icon-arrow-down el-icon--right"></i>
                  </button>
                  <el-dropdown-menu slot="dropdown" class="cc-page__action-menu">
                    <el-dropdown-item command="edit">
                      <div class="cc-page__action-item">
                        <span class="cc-page__action-icon"
                          ><font-awesome-icon :icon="['fas', 'pen']"
                        /></span>
                        <span
                          @click="
                            loadCompanies();
                            getListCategory();
                          "
                          >Update Referral Program</span
                        >
                      </div>
                    </el-dropdown-item>

                    <el-dropdown-item command="status">
                      <div class="cc-page__action-item">
                        <span class="cc-page__action-icon">
                          <font-awesome-icon :icon="['fas', 'pen']" />
                        </span>
                        <span> Update Status</span>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- v-model="showModalCreateReferralProgram" -->

        <b-modal
          v-model="showModalCreateReferralProgram"
          size="xl"
          id="add"
          title="Create Referral Program"
          hide-footer
          @hide="closeModalReferralProgram"
        >
          <div class="company-client-modal">
            <div class="company-client-modal__intro">
              <div class="company-client-modal__eyebrow">Referral Feature</div>
              <div class="company-client-modal__lede">
                Create and configure a new referral program campaign, set transaction amounts,
                manage targeted companies, and define terms and conditions.
              </div>
            </div>

            <b-form @submit.prevent="createReferralProgram" @reset="closeModalReferralProgram">
              <section class="company-client-modal__section">
                <div class="company-client-modal__section-head">
                  <h4>General Information</h4>
                  <p>Define the program name, target category, and specific code prefixes.</p>
                </div>

                <div class="company-client-modal__grid">
                  <div class="ds-field">
                    <label class="ds-field__label">Referral Category</label>
                    <el-select
                      class="w-full"
                      size="small"
                      v-model="referral.referral_category_id"
                      placeholder="Select Referral Category"
                    >
                      <el-option
                        v-for="category in listCategory"
                        :key="category.id"
                        :value="category.id"
                        :label="category.name"
                      />
                    </el-select>
                    <span class="text-red-600 text-xs" v-if="!referral.referral_category_id"
                      >*Value is required</span
                    >
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">Program Name</label>
                    <el-input
                      size="small"
                      placeholder="Input Program Name"
                      v-model="referral.name"
                    />
                    <span class="text-red-600 text-xs" v-if="!referral.name"
                      >*Value is required</span
                    >
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">Prefix Code Referral</label>
                    <el-input
                      size="small"
                      placeholder="Input prefix code referral"
                      v-model="referral.prefix_code_referral"
                    />
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">Period</label>
                    <el-select
                      class="w-full"
                      size="small"
                      v-model="referral.period"
                      placeholder="Select Period"
                    >
                      <el-option
                        v-for="period in period_list"
                        :key="period.value"
                        :value="period.value"
                        :label="period.name"
                      />
                    </el-select>
                    <span class="text-red-600 text-xs" v-if="!referral.period"
                      >*Value is required</span
                    >
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">Start Date</label>
                    <el-date-picker
                      :picker-options="datePickerStartOptions"
                      class="w-full"
                      v-model="referral.start_date"
                      type="date"
                      placeholder="Pick start date"
                      format="dd MMMM yyyy"
                      value-format="yyyy-MM-dd"
                      @input="updateEndDatePickerOptions"
                    />

                    <span class="text-red-600 text-xs" v-if="!referral.start_date"
                      >*Value is required</span
                    >
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">End Date</label>
                    <el-date-picker
                      :picker-options="datePickerEndOptions"
                      :key="endDateKey"
                      class="w-full"
                      v-model="referral.end_date"
                      type="date"
                      placeholder="Pick end date"
                      format="dd MMMM yyyy"
                      value-format="yyyy-MM-dd"
                    />

                    <span class="text-red-600 text-xs" v-if="!referral.end_date"
                      >*Value is required</span
                    >
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">Is Auto Claim</label>
                    <el-select
                      class="w-full"
                      size="small"
                      v-model="referral.is_auto_claim"
                      placeholder="Select Auto Claim"
                    >
                      <el-option
                        v-for="period in is_auto_claim_list"
                        :key="period.value"
                        :value="period.value"
                        :label="period.name"
                      />
                    </el-select>
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">Description</label>
                    <el-input
                      size="small"
                      placeholder="Input description"
                      v-model="referral.description"
                    />
                    <span class="text-red-600 text-xs" v-if="!referral.description"
                      >*Value is required</span
                    >
                  </div>
                </div>
              </section>

              <section class="company-client-modal__section">
                <div class="company-client-modal__section-head">
                  <h4>Company Targeting</h4>
                  <p>
                    Include or exclude specific companies for this referral program distribution.
                  </p>
                </div>

                <div class="company-client-modal__grid">
                  <div class="ds-field">
                    <label class="ds-field__label">Include Company</label>
                    <el-select
                      multiple
                      size="small"
                      :loading="loading.company"
                      v-model="referral.include_company"
                      placeholder="Select or search company"
                      style="width: 100%"
                      filterable
                      remote
                      :remote-method="searchCompany"
                    >
                      <el-option
                        v-for="item in companies.rows"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      />
                    </el-select>
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">Exclude Company</label>
                    <el-select
                      multiple
                      size="small"
                      :loading="loading.company"
                      v-model="referral.exclude_company"
                      placeholder="Select or search company"
                      style="width: 100%"
                      filterable
                      remote
                      :remote-method="searchCompany"
                      :disabled="referral.include_company && referral.include_company.length > 0"
                    >
                      <el-option
                        v-for="item in companies.rows"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      />
                    </el-select>
                  </div>
                </div>
                <br />
                <div class="company-client-modal__grid">
                  <div class="ds-field">
                    <label class="ds-field__label">company exchange referral</label>
                    <el-select
                      multiple
                      size="small"
                      :loading="loading.company"
                      v-model="referral_edit.company_exchange_referral"
                      placeholder="Select or search company"
                      style="width: 100%"
                      filterable
                      remote
                      :remote-method="searchCompany"
                    >
                      <el-option
                        v-for="item in companies.rows"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      />
                    </el-select>
                  </div>
                </div>
              </section>

              <section class="company-client-modal__section">
                <div class="company-client-modal__section-head">
                  <h4>Reward Configurations</h4>
                  <p>Set up the pricing matrix allocations and limitation rules for claims.</p>
                </div>

                <div class="company-client-modal__grid">
                  <div class="ds-field">
                    <label class="ds-field__label">Referrer Amount</label>
                    <b-input
                      size="small"
                      placeholder="Input referrer amount"
                      v-model="referral.referrer_amount"
                      type="number"
                    />
                    <span class="text-red-600 text-xs" v-if="!referral.referrer_amount"
                      >*Value is required</span
                    >
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">Referred Amount</label>
                    <b-input
                      size="small"
                      placeholder="Input referred amount"
                      v-model="referral.referred_amount"
                      type="number"
                    />
                    <span class="text-red-600 text-xs" v-if="!referral.referred_amount"
                      >*Value is required</span
                    >
                  </div>

                  <div class="ds-field company-client-modal__field-full">
                    <label class="ds-field__label">Max Claim</label>
                    <b-input
                      size="small"
                      v-model="referral.max_claim"
                      placeholder="Input maximal claim"
                      type="number"
                    />
                    <span class="text-red-600 text-xs" v-if="!referral.max_claim"
                      >*Value is required</span
                    >
                  </div>
                </div>
              </section>

              <section class="company-client-modal__section">
                <div class="company-client-modal__section-head">
                  <h4>Terms, Conditions</h4>
                  <p>Provide policy documentation details and distribution text templates.</p>
                </div>

                <div class="company-client-modal__grid">
                  <div class="ds-field company-client-modal__field-full">
                    <label class="ds-field__label">Term and Condition</label>
                    <div class="editor-wrapper" style="margin-bottom: 50px">
                      <quill-editor
                        v-model="referral.tnc"
                        ref="tnc"
                        :options="editorOption"
                        style="height: 150px"
                      />
                    </div>
                  </div>
                  <br />

                  <div class="ds-field company-client-modal__field-full">
                    <label class="ds-field__label">Info Share</label>
                    <b-textarea
                      rows="4"
                      v-model="referral.info_share"
                      placeholder="Input info share code referral"
                    />
                  </div>
                </div>
              </section>
            </b-form>

            <div class="company-client-modal__actions">
              <button
                class="ds-btn ds-btn--secondary ds-btn--sm"
                @click="closeModalReferralProgram"
              >
                Cancel
              </button>
              <button
                class="ds-btn btn-primary ds-btn--sm"
                :disabled="
                  !referral.referral_category_id ||
                  !referral.description ||
                  !referral.name ||
                  !referral.referrer_amount ||
                  !referral.referred_amount ||
                  !referral.period
                "
                @click="createReferralProgram"
              >
                Submit Referral
              </button>
            </div>
          </div>
        </b-modal>

        <b-modal
          size="xl"
          v-model="showDetailID"
          :title="'Edit Referral Program #' + editID"
          hide-footer
          @hide="closeModalEdit"
        >
          <div class="company-client-modal">
            <div class="company-client-modal__intro">
              <div class="company-client-modal__eyebrow">Referral Feature</div>
              <div class="company-client-modal__lede">
                Update the configuration rules, targeting constraints, operational status, and legal
                policy documentation for this specific referral campaign.
              </div>
            </div>

            <b-form @submit.prevent="doUpdateData" @reset="closeModalReferralProgram">
              <section class="company-client-modal__section">
                <div class="company-client-modal__section-head">
                  <h4>Parameters & Controls</h4>
                  <p>Manage general program execution ceilings and deployment states.</p>
                </div>

                <div class="company-client-modal__grid">
                  <div class="ds-field">
                    <label class="ds-field__label">Max Claim</label>
                    <b-input
                      v-model="referral_edit.max_claim"
                      size="small"
                      placeholder="Input maximal claim"
                      type="number"
                    />
                    <span class="text-red-600 text-xs" v-if="!referral_edit.max_claim"
                      >*Value is required</span
                    >
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">Status</label>
                    <el-select
                      class="w-full"
                      size="small"
                      v-model="referral_edit.status"
                      placeholder="Select Referral status"
                    >
                      <el-option
                        v-for="status in status_options"
                        :key="status.value"
                        :value="status.value"
                        :label="status.text"
                      />
                    </el-select>
                  </div>
                  <div class="ds-field">
                    <label class="ds-field__label">Start Date</label>
                    <el-date-picker
                      :picker-options="datePickerStartOptions"
                      class="w-full"
                      v-model="referral_edit.start_date"
                      type="date"
                      placeholder="Pick start date"
                      format="dd MMMM yyyy"
                      value-format="yyyy-MM-dd"
                      @input="updateEndDatePickerOptions"
                    />

                    <span class="text-red-600 text-xs" v-if="!referral_edit.start_date"
                      >*Value is required</span
                    >
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">End Date</label>
                    <el-date-picker
                      :picker-options="datePickerEndOptions"
                      :key="endDateKey"
                      class="w-full"
                      v-model="referral_edit.end_date"
                      type="date"
                      placeholder="Pick end date"
                      format="dd MMMM yyyy"
                      value-format="yyyy-MM-dd"
                    />

                    <span class="text-red-600 text-xs" v-if="!referral_edit.end_date"
                      >*Value is required</span
                    >
                  </div>
                </div>
              </section>

              <section class="company-client-modal__section">
                <div class="company-client-modal__section-head">
                  <h4>Company Targeting</h4>
                  <p>
                    Include or exclude specific companies for this referral program distribution.
                  </p>
                </div>

                <div class="company-client-modal__grid">
                  <div class="ds-field">
                    <label class="ds-field__label">Include Company</label>
                    <el-select
                      multiple
                      size="small"
                      :loading="loading.company"
                      v-model="referral_edit.include_company"
                      placeholder="Select or search company"
                      style="width: 100%"
                      filterable
                      remote
                      :remote-method="searchCompany"
                    >
                      <el-option
                        v-for="item in companies.rows"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      />
                    </el-select>
                  </div>

                  <div class="ds-field">
                    <label class="ds-field__label">Exclude Company</label>
                    <el-select
                      multiple
                      size="small"
                      :loading="loading.company"
                      v-model="referral_edit.exclude_company"
                      placeholder="Select or search company"
                      style="width: 100%"
                      filterable
                      remote
                      :remote-method="searchCompany"
                      :disabled="
                        referral_edit.include_company && referral_edit.include_company.length > 0
                      "
                    >
                      <el-option
                        v-for="item in companies.rows"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      />
                    </el-select>
                  </div>
                </div>

                <br />

                <div class="company-client-modal__grid">
                  <div class="ds-field">
                    <label class="ds-field__label">company exchange referral</label>
                    <el-select
                      multiple
                      size="small"
                      :loading="loading.company"
                      v-model="referral_edit.company_exchange_referral"
                      placeholder="Select or search company"
                      style="width: 100%"
                      filterable
                      remote
                      :remote-method="searchCompany"
                    >
                      <el-option
                        v-for="item in companies.rows"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      />
                    </el-select>
                  </div>
                </div>
              </section>

              <section class="company-client-modal__section">
                <div class="company-client-modal__section-head">
                  <h4>Terms & Conditions</h4>
                  <p>Provide policy documentation details and distribution text templates.</p>
                </div>

                <div class="company-client-modal__grid">
                  <div class="ds-field company-client-modal__field-full">
                    <label class="ds-field__label">Term and Condition</label>
                    <div class="editor-wrapper" style="margin-bottom: 50px">
                      <quill-editor
                        v-model="referral_edit.tnc"
                        ref="tnc_edit"
                        :options="editorOption"
                        style="height: 150px"
                      />
                    </div>
                    <br />
                  </div>
                  <br />

                  <div class="ds-field company-client-modal__field-full">
                    <label class="ds-field__label">Info Share</label>
                    <b-textarea
                      rows="4"
                      v-model="referral_edit.info_share"
                      placeholder="Input info share code referral"
                    />
                  </div>
                </div>
              </section>
            </b-form>

            <div class="company-client-modal__actions">
              <button class="ds-btn ds-btn--secondary ds-btn--sm" @click="closeModalEdit">
                Cancel
              </button>
              <button class="ds-btn ds-btn--primary ds-btn--sm" @click="doUpdateData">
                Submit
              </button>
            </div>
          </div>
        </b-modal>
        <b-modal
          size="xl"
          v-model="showDetailStatusID"
          :title="'Edit Status Refferal #' + editID"
          hide-footer
          @hide="closeModalEdit"
        >
          <div class="company-client-modal">
            <div class="company-client-modal__intro">
              <div class="company-client-modal__eyebrow">Referral Feature</div>
              <div class="company-client-modal__lede">
                Update the configuration rules, targeting constraints, operational status, and legal
                policy documentation for this specific referral campaign.
              </div>
            </div>

            <b-form @submit.prevent="doUpdateData" @reset="closeModalReferralProgram">
              <section class="company-client-modal__section">
                <div class="company-client-modal__section-head">
                  <h4>Parameters & Controls</h4>
                  <p>Manage general program execution ceilings and deployment states.</p>
                </div>

                <div class="company-client-modal__grid">
                  <div class="ds-field">
                    <label class="ds-field__label">Status</label>
                    <el-select
                      class="w-full"
                      size="small"
                      v-model="referral_edit_status.status"
                      placeholder="Select Referral status"
                    >
                      <el-option
                        v-for="status in status_options"
                        :key="status.value"
                        :value="status.value"
                        :label="status.text"
                      />
                    </el-select>
                    <!-- :disabled="isStatusDisabled(status.value)" -->
                  </div>
                </div>
              </section>
            </b-form>

            <div class="company-client-modal__actions">
              <button class="ds-btn ds-btn--secondary ds-btn--sm" @click="closeModalEditStatus">
                Cancel
              </button>
              <button class="ds-btn ds-btn--primary ds-btn--sm" @click="doUpdateStatus">
                Submit
              </button>
            </div>
          </div>
        </b-modal>
        <el-empty
          description="No data found"
          v-if="total_rows == 0"
          :image="emptyStateImage"
        ></el-empty>
      </div>

      <pagination
        :page="page"
        :per_page="per_page"
        :list="list"
        :total_rows="total_rows"
        @pageChange="pageChangeHandler"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { upperFirst } from 'lodash';
import emptyStateImage from '@/assets/images/empty-state.png';
import Pagination from '../components/Pagination.vue';
import { GET_COMPANIES } from '@/store/modules/companies';
import {
  CREATE_REFERRAL_PROGRAM,
  GET_REFERRAL_PROGRAM,
  EDIT_REFERRAL_PROGRAM,
  GET_CATEGORIES,
  EDIT_STATUS_REFERRAL,
} from '@/store/modules/app_user';
import popupErrorMessages from '@/library/popup-error-messages';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
export default {
  components: {
    Pagination,
    quillEditor,
  },
  name: 'Referral',
  metaInfo: {
    title: 'Referral Program',
  },
  data() {
    return {
      originalStatus: null,
      endDateKey: 0,
      datePickerStartOptions: {
        disabledDate: (date) => moment(date).isBefore(moment(), 'days'),
      },
      datePickerEndOptions: {
        disabledDate: (date) => moment(date).isBefore(moment(), 'days'),
      },
      loading: {
        submit: false,
        company: false,
        balance: false,
      },
      show: false,
      companies: {
        rows: [],
        count: 0,
      },
      timeoutSearchCompany: null,
      showModalCreateReferralProgram: false,
      editID: null,
      editStatusID: null,
      showDetailID: false,
      showDetailStatusID: false,
      company_id: 6667,
      referral: {
        company_exchange_referral: [],
        referral_category_id: '',
        name: '',
        description: '',
        referrer_amount: 0,
        referred_amount: 0,
        user_id: null,
        max_claim: 0,
        period: '',
        prefix_code_referral: '',
        exclude_company: [],
        include_company: [],
        is_auto_claim: false,
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(7, 'days').format('YYYY-MM-DD'),
        status: [],
        tnc: '',
        info_share: '',
      },
      editorOption: {
        placeholder: '1. Referral Ewa adalah program ...',
      },
      referral_edit: {
        status: 0,
        max_claim: 0,
        user_id: null,
        exclude_company: [],
        include_company: [],
        tnc: '',
        info_share: '',
        company_exchange_referral: [],
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(7, 'days').format('YYYY-MM-DD'),
      },
      referral_edit_status: {
        status: 0,
        user_id: null,
      },
      period_list: [
        { name: 'Month', value: 'month' },
        { name: 'Week', value: 'week' },
        { name: 'Daily', value: 'day' },
        { name: 'Year', value: 'year' },
      ],
      is_auto_claim_list: [
        { name: 'Yes', value: true },
        { name: 'No', value: false },
      ],
      category: {
        name: '',
        user_id: null,
      },
      get_referral_program: {
        rows: [],
        count: 0,
      },
      user_id: null,
      showSearch: true,
      emptyStateImage,
      per_page: 10,
      size: 10,
      total_rows: 0,
      total_rows_categories: 0,
      page: 1,
      list: [],
      listCategory: [],
      data_ref: [],
      isLoading: true,
      loading_detail: false,
      loader: null,
      sort_by: 'desc',
      order_by: 'id',
      search_referral: {
        sort_by: '',
        order_by: '',
        search: 'name',
        search_value: '',
      },
      sortByOptions: [
        {
          value: 'asc',
          label: 'Asc',
        },
        {
          value: 'desc',
          label: 'Desc',
        },
      ],
      orderByOptions: [
        {
          value: 'id',
          label: 'ID',
        },
        {
          value: 'name',
          label: 'Name',
        },
      ],
      search_value: '',
      search: '',
      search_options: [{ value: 'name', text: 'Name' }],
      status_options: [
        { value: 1, text: 'Active' },
        { value: 0, text: 'Draft' },
        { value: 2, text: 'Maintenance' },
        { value: 3, text: 'Coming Soon' },
        { value: 4, text: 'Under Review' },
        { value: 5, text: 'Non Active' },
      ],
      datePickerOptions: {
        disabledDate: (date) => moment(date).isBefore(moment(), 'days'),
      },
    };
  },
  async created() {
    // REFERRAL PROGRAM
    this.referral.user_id = localStorage.getItem('user_id');
    // CATEGORY
    this.category.user_id = localStorage.getItem('user_id');
  },
  async mounted() {
    const loader = this.$loading.show();
    this.page = 1;
    await this.getList();
    // await this.getListCategory();
    // await this.loadCompanies();
    loader.hide();
  },
  computed: {
    showingFrom() {
      return this.total_rows ? (this.page - 1) * this.per_page + 1 : 0;
    },
    showingUntil() {
      if (this.total_rows) {
        if (this.list.length < this.per_page) {
          return this.total_rows;
        }
        return this.page * this.per_page;
      }
      return 0;
    },
    formattedNew: {
      get() {
        return this.formatNumber(this.referral.referred_amount);
      },
      set(value) {
        this.referral.referred_amount = this.parseFormattedNumber(value);
      },
    },
    formattedValue: {
      get() {
        return this.formatNumber(this.referral.referrer_amount);
      },
      set(value) {
        this.referral.referrer_amount = this.parseFormattedNumber(value);
      },
    },
    formattedDataLog() {
      return this.log_dipay.map((item) => ({
        vendor_id: item.data.vendor_id,
      }));
    },
  },
  methods: {
    isStatusDisabled(targetValue) {
      if (this.originalStatus === targetValue) return false;
      switch (this.originalStatus) {
        case 1: // Active
          return ![1, 2, 3, 5].includes(targetValue);
        case 3: // Coming Soon
          return ![3, 1, 5].includes(targetValue);
        case 2: // Maintenance
          return ![2, 1, 5].includes(targetValue);
        case 4: // Under Review
          return ![4, 1, 5].includes(targetValue);
        case 0: // Draft
          return ![0, 4].includes(targetValue);
        default:
          return false;
      }
    },
    updateEndDatePickerOptions() {
      if (this.referral.start_date) {
        const selectedStartDate = moment(this.referral.start_date, 'YYYY-MM-DD');
        this.datePickerEndOptions = {
          disabledDate: (date) => {
            const selectedDate = moment(date);
            const isDisabled =
              selectedDate.isBefore(moment(), 'days') ||
              selectedDate.isBefore(selectedStartDate, 'day');
            return isDisabled;
          },
        };
        this.endDateKey += 1;
      }
    },
    pageChangeHandler(page) {
      this.page = page;
      this.getList();
    },
    searchHandler() {
      this.search_referral.sort_by = this.search_referral.sort_by;
      this.search_referral.order_by = this.search_referral.order_by;
      this.search_referral.search = this.search_referral.search;
      this.search_referral.search_value = this.search_referral.search_value;
      this.getList();
    },
    // ref
    formatNumber(value) {
      if (typeof value !== 'string') {
        value = String(value);
      }
      value = value.replace(/[^0-9.]/g, '');
      const parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    parseFormattedNumber(value) {
      return value.replace(/,/g, '');
    },
    // REFERRAL FIX
    async createReferralProgram() {
      this.referral.referral_category_id = parseInt(this.referral.referral_category_id);
      this.referral.referrer_amount = parseInt(this.referral.referrer_amount);
      this.referral.referred_amount = parseInt(this.referral.referred_amount);
      this.referral.max_claim = parseInt(this.referral.max_claim);
      try {
        const requestBody = {
          referral_category_id: this.referral.referral_category_id,
          name: this.referral.name,
          exclude_company: this.referral.exclude_company,
          include_company: this.referral.include_company,
          start_date: this.referral.start_date,
          end_date: this.referral.end_date,
          is_auto_claim: this.referral.is_auto_claim,
          company_exchange_referral: this.referral.company_exchange_referral,
          description: this.referral.description,
          referrer_amount: this.referral.referrer_amount,
          referred_amount: this.referral.referred_amount,
          user_id: this.referral.user_id,
          max_claim: this.referral.max_claim,
          period: this.referral.period,
          prefix_code_referral: this.referral.prefix_code_referral,
          tnc: this.referral.tnc,
          info_share: this.referral.info_share,
        };
        const response = await this.$store.dispatch(CREATE_REFERRAL_PROGRAM, { data: requestBody });
        this.referral.referral_category_id = '';
        this.referral.name = '';
        this.referral.exlude_company = '';
        (this.referral.description = ''),
          (this.referral.referred_amount = ''),
          (this.referral.user_id = ''),
          (this.referral.max_claim = ''),
          (this.referral.period = ''),
          (this.referral.prefix_code_referral = ''),
          (this.referral.include_company = ''),
          (this.referral.is_auto_claim = ''),
          (this.referral.company_exchange_referral = ''),
          (this.referral.info_share = ''),
          (this.referral.tnc = ''),
          (this.data_ref = response);
        this.$message({
          title: 'Success',
          type: 'success',
          message: 'Referral Program created',
        });
        this.closeModalReferralProgram();
        this.getList();
      } catch (err) {
        popupErrorMessages(err.response.data);
      }
    },
    // del
    confirmCreateReferralProgram() {
      if (this.modalType === 'add') {
        this.doCreateReferralProgram();
        return;
      }
      this.$confirm(
        'You will create a new Referral Program. Make sure you have input data correctly. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              this.doCreateReferralProgram();
            }
            done();
          },
        }
      ).catch(() => {});
    },
    // CREATE_REFERRAL_PROGRAM
    async doCreateReferralProgram() {
      this.referral.referral_category_id = parseInt(this.referral.referral_category_id);
      this.referral.referrer_amount = parseInt(this.referral.referrer_amount);
      this.referral.referred_amount = parseInt(this.referral.referred_amount);
      this.referral.max_claim = parseInt(this.referral.max_claim);
      await this.$store
        .dispatch(CREATE_REFERRAL_PROGRAM, this.referral)
        .then(() => {
          this.$message({
            title: 'Success',
            type: 'success',
            message: 'Referral Program created',
          });
          // this.closeModalReferralProgram();
          this.getList();
        })
        .catch((err) => {
          popupErrorMessages(err.response.data);
        });
    },
    closeModalReferralProgram() {
      (this.showModalCreateReferralProgram = false),
        (this.referral = {
          referral_category_id: '',
          name: '',
          exclude_company: [],
          include_company: [],
          start_date: moment().format('YYYY-MM-DD'),
          end_date: moment().add(7, 'days').format('YYYY-MM-DD'),
          description: '',
          referred_amount: '',
          user_id: '',
          max_claim: '',
          period: '',
          prefix_code_referral: '',
          tnc: '',
          info_share: '',
          company_exchange_referral: [],
          is_auto_claim: '',
          referrer_amount: '',
        });
    },
    closeModalEdit() {
      this.showDetailID = false;
    },
    closeModalEditStatus() {
      this.showDetailStatusID = false;
    },
    async getList() {
      await this.$store
        .dispatch(GET_REFERRAL_PROGRAM, {
          page: this.page,
          // per_page: this.per_page,
          sort_by: this.search_referral.sort_by,
          order_by: this.search_referral.order_by,
          search: this.search_referral.search,
          search_value: this.search_referral.search_value,
        })
        .catch(() => {});
      const { rows, count } = this.$store.getters.get_referral_program;
      this.total_rows = count || 0;
      this.list = rows;
    },
    async getListCategory() {
      await this.$store.dispatch(GET_CATEGORIES, this.filter).catch(() => {});
      const { rows, count } = this.$store.getters.get_categories;
      this.total_rows_categories = count || 0;
      this.listCategory = rows;
    },
    editByID(id) {
      this.editID = id;
      this.showDetailID = true;
      const selectedItem = this.list.find((item) => item.id === id);
      this.referral_edit.user_id = selectedItem ? selectedItem.user_id : null;
      this.referral_edit.max_claim = selectedItem ? selectedItem.max_claim : 0;
      this.referral_edit.status = selectedItem ? selectedItem.status : '';
      this.referral_edit.start_date =
        selectedItem && selectedItem.start_date
          ? moment(selectedItem.start_date).utcOffset('+07:00').format('YYYY-MM-DD')
          : '';
      this.referral_edit.end_date =
        selectedItem && selectedItem.end_date
          ? moment(selectedItem.end_date).utcOffset('+07:00').format('YYYY-MM-DD')
          : '';
      this.referral_edit.company_exchange_referral = selectedItem
        ? selectedItem.company_exchange_referral
        : [];
      this.referral_edit.description = selectedItem ? selectedItem.description : '';
      (this.referral_edit.exclude_company = selectedItem ? selectedItem.exclude_company : []),
        (this.referral_edit.include_company = selectedItem ? selectedItem.include_company : []),
        (this.referral_edit.tnc = selectedItem ? selectedItem.tnc : '');
      this.referral_edit.info_share = selectedItem ? selectedItem.info_share : '';
    },
    editByStatusID(id) {
      this.editStatusID = id;
      this.showDetailStatusID = true;
      const selectedItem = this.list.find((item) => item.id === id);
      this.referral_edit.user_id = selectedItem ? selectedItem.user_id : null;
      this.referral_edit.max_claim = selectedItem ? selectedItem.max_claim : 0;
      this.referral_edit.status = selectedItem ? selectedItem.status : '';
      this.referral_edit_status.status = selectedItem ? selectedItem.status : '';
      this.referral_edit.start_date = selectedItem ? selectedItem.start_date : '';
      this.referral_edit.end_date = selectedItem ? selectedItem.end_date : '';
      this.referral_edit.company_exchange_referral = selectedItem
        ? selectedItem.company_exchange_referral
        : [];
      this.referral_edit.description = selectedItem ? selectedItem.description : '';
      (this.referral_edit.exclude_company = selectedItem ? selectedItem.exclude_company : []),
        (this.referral_edit.include_company = selectedItem ? selectedItem.include_company : []),
        (this.referral_edit.tnc = selectedItem ? selectedItem.tnc : '');
      this.referral_edit.info_share = selectedItem ? selectedItem.info_share : '';
    },
    async doUpdateData(id) {
      this.referral_edit.max_claim = parseInt(this.referral_edit.max_claim);
      this.referral_edit.status = parseInt(this.referral_edit.status);
      this.$confirm(
        'You will update this program referral. Make sure you have input data correctly. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              done();
              const payload = {
                id: this.editID,
                data: this.referral_edit,
              };
              await this.$store
                .dispatch(EDIT_REFERRAL_PROGRAM, payload)
                .then(() => {
                  this.$message({
                    title: 'Success',
                    type: 'success',
                    message: 'Program referral updated',
                  });
                  this.showDetailID = false;
                  this.getList();
                })
                .catch((err) => {
                  popupErrorMessages(err.response.data);
                });
              return;
            }
            done();
          },
        }
      ).catch(() => {});
    },

    async doUpdateStatus(id) {
      const userId = this.referral.user_id;
      this.referral_edit_status.user_id = userId;
      this.$confirm(
        'You will update this program referral. Make sure you have input data correctly. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              done();
              const payload = {
                id: this.editStatusID,
                // data: this.referral_edit_status.status,
                data: this.referral_edit_status,
              };
              await this.$store
                .dispatch(EDIT_STATUS_REFERRAL, payload)
                .then(() => {
                  this.$message({
                    title: 'Success',
                    type: 'success',
                    message: 'Status referral updated',
                  });
                  this.showDetailStatusID = false;
                  this.getList();
                })
                .catch((err) => {
                  popupErrorMessages(err.response.data);
                });
              return;
            }
            done();
          },
        }
      ).catch(() => {});
    },
    async resetFilters() {
      this.search_referral = {
        sort_by: '',
        order_by: '',
        search: 'name',
        search_value: '',
      };
      this.page = 1;
      await this.getList();
    },
    handleActionCommand(command, item) {
      if (command === 'edit') {
        this.editByID(item.id);
      }
      if (command === 'status') {
        this.editByStatusID(item.id);
      }
    },
    async loadCompanies({ search_keyword = '' } = {}) {
      this.loading.company = true;
      await this.$store.dispatch(GET_COMPANIES, {
        search_keyword,
      });
      this.loading.company = false;
      this.companies = this.$store.getters.companies;
    },
    searchCompany(value) {
      clearTimeout(this.timeoutSearchCompany);
      this.timeoutSearchCompany = setTimeout(() => {
        this.loadCompanies({
          search_keyword: value,
        });
      }, 1000);
    },
  },
  watch: {
    isShown() {
      this.show = this.isShown;
      this.v$.form.$touch();
      if (this.show) {
        this.loadCompanies();
        this.getListCategory();
      }
    },
    'referral.include_company'(newVal) {
      if (newVal && newVal.length > 0) {
        this.referral.exclude_company = [];
      }
    },
  },
  props: {
    // isShown: {
    //   type: Boolean,
    //   default: false,
    // },
  },
};
</script>
<style>
.el-range-separator {
  width: 10% !important;
}

.child1-sticky {
  position: sticky;
  right: 0px;
  width: 40px;
  background: #fff;
}

.child2-sticky {
  position: sticky;
  right: 69px;
  width: 255px;
  background: #fff;
}
/* del */
.table-container {
  width: 100%;
  overflow-x: auto;
}

.table-responsive {
  overflow-x: auto;
}

.buttonload {
  background-color: #006ea5; /* Green background */
  border: none; /* Remove borders */
  color: white; /* White text */
  padding: 12px 16px; /* Some padding */
  font-size: 16px; /* Set a font size */
}

.dialog-footer button:first-child {
  margin-right: 10px;
}

.company-client-modal__intro {
  margin-bottom: 18px;
  padding: 14px 16px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(32, 107, 196, 0.08), rgba(32, 107, 196, 0.04));
}

.company-client-modal__eyebrow {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #206bc4;
  margin-bottom: 6px;
}

.company-client-modal__lede {
  font-size: 13px;
  color: #4b5563;
}

.company-client-modal__section + .company-client-modal__section {
  margin-top: 18px;
}

.company-client-modal__section-head {
  margin-bottom: 12px;
}

.company-client-modal__section-head h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #182433;
}

.company-client-modal__section-head p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #656d77;
}

.company-client-modal__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.company-client-modal__field-full {
  grid-column: 1 / -1;
}

.company-client-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 22px;
}

/* Fallback styles for ds-field variables if not present globally */
.ds-field {
  display: flex;
  flex-direction: column;
}

.ds-field__label {
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  margin-bottom: 6px;
}

@media (max-width: 768px) {
  .company-client-modal__grid {
    grid-template-columns: 1fr;
  }
}

.rf-page__filter-layout {
  grid-template-columns: repeat(4, minmax(0, 1fr)) auto !important;
}

.rf-page__filter-actions {
  align-self: end;
}

.font-weight-bold {
  font-weight: 600;
}

.ds-pill--secondary {
  background-color: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

@media (max-width: 1200px) {
  .rf-page__filter-layout {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .rf-page__filter-actions {
    grid-column: 1 / -1;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .rf-page__filter-layout {
    grid-template-columns: 1fr !important;
  }
  .rf-page__filter-actions {
    justify-content: flex-start;
  }
}

.cc-page__header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cc-page__table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 6px;
}

.cc-page__filter-card {
  margin-bottom: 14px;
}

.cc-page__filter-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr auto;
  gap: 12px;
  padding: 8px 20px 18px;
  align-items: end;
}

.cc-page__filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.cc-page__table-title {
  font-size: 15px;
  font-weight: 700;
  color: #182433;
}

.cc-page__table-subtitle {
  font-size: 12px;
  color: #656d77;
  margin-top: 4px;
}

.cc-page__identity {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cc-page__identity-name {
  font-weight: 700;
  color: #182433;
}

.cc-page__identity-sub {
  font-size: 12px;
  color: #656d77;
}

.cc-page__action-trigger {
  min-width: 108px;
  justify-content: center;
}

.cc-page__pks-cell {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
}

.cc-page__pks-pill {
  width: fit-content;
}

.cc-page__action-menu {
  padding: 8px;
}

.cc-page__action-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 190px;
  color: #1f2937;
}

.cc-page__action-item--danger {
  color: #c0392b;
}

.cc-page__action-icon {
  width: 18px;
  text-align: center;
}

.company-client-modal {
  padding: 6px 2px 2px;
}

.company-client-modal__intro {
  margin-bottom: 16px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(32, 107, 196, 0.08);
  color: #304152;
  font-size: 13px;
}

.company-client-modal__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.company-client-modal__field-full {
  grid-column: 1 / -1;
}

.company-client-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

@media (max-width: 900px) {
  .cc-page__filter-grid {
    grid-template-columns: 1fr;
  }

  .cc-page__filter-actions {
    justify-content: flex-start;
  }

  .company-client-modal__grid {
    grid-template-columns: 1fr;
  }
}
</style>
